import type { CategoryChain } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import React from 'react'

import { Tag } from 'rsuite'
import AppLoader from '@components/common/AppLoader'

export interface ProductCategoriesSelectedItemsProps {
  items?: CategoryChain[]
  loading?: boolean
  onCategoryDrop(id: GQL_ID): void
  nameDelimiter?: string
}

export default function ProductCategoriesSelectedItems ({
  items = [],
  loading = false,
  onCategoryDrop,
  nameDelimiter = ' -> '
}: ProductCategoriesSelectedItemsProps) {
  if (!items) {
    return null
  }

  return (
    <div style={{ flexDirection: 'row'}}>
      {loading && <AppLoader.Inner content="Загрузка категорий" />}

      {items.map((item) => (
        <Tag 
          closable 
          onClose={() => onCategoryDrop(item.id)}
          key={`SelectedCategory:${item.id}`}
          className='my-2'
        >
          {item.namesChain.join(nameDelimiter)}
        </Tag>
      ))}
    </div>
  )
}
